import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { PersonVolunteeringRow } from '../person-volunteering.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService): GridSetup<PersonVolunteeringRow> {

	return {
		rowName: { singular: 'Volunteering', plural: 'Volunteerings' },
		getRowKey: row => row.programId + '_' + row.role + '_' + row.id,
		stateKey: 'person-explorer-volunteering-grid',
		actions: getActions(dialog),
		buttons: getButtons(),
		columns: getColumns(util),
	}
}
